<script setup lang="ts">
import { Color } from "~/core/models/Color.enum";
import { CampaignOMStatus } from "~/modules/campaign/models/CampaignOMStatus.enum";

const props = defineProps<{
  status: CampaignOMStatus;
}>();

const { t } = useI18n();

const textWhite: Ref<boolean> = ref(false);

const badgeType = computed<string>(() => {
  let type: string;
  textWhite.value = false;
  switch (props.status) {
    case CampaignOMStatus.SCHEDULED:
      type = Color.SECONDARY;
      break;
    case CampaignOMStatus.RUNNING:
      type = Color.PRIMARY;
      textWhite.value = true;
      break;
    case CampaignOMStatus.COMPLETE:
      type = Color.SUCCESS;
      break;
    case CampaignOMStatus.CANCELLING:
    case CampaignOMStatus.CANCELLED:
    case CampaignOMStatus.COMPLETE_WITH_ERRORS:
    case CampaignOMStatus.INCOMPLETE:
    default:
      type = Color.DANGER;
      break;
  }
  return type;
});

const statusTranslation = computed(() => {
  if (Object.values(CampaignOMStatus).includes(props.status)) {
    return t(`campaign.list.column.status.value.${props.status}`);
  }
  return t(`campaign.list.column.status.value.UNKNOWN`);
});
</script>

<template>
  <lxc-badge v-if="status !== null" :type="badgeType" :text-white="textWhite">
    {{ statusTranslation }}
  </lxc-badge>
</template>
